/* Return cursor position relative to element */
export function getMousePos (el, evt) {
  const rect = el.getBoundingClientRect()
  return {
    x: evt.clientX - rect.left,
    y: evt.clientY - rect.top
  }
}
